export function InfoIcon(props) {
  return (
    <svg
      height='24'
      id='Layer_1'
      style={{
        padding: '3px',
      }}
      version='1.1'
      viewBox='0 0 512 512'
      width='24'
      xmlSpace='preserve'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <g>
        <path
          d='M318.5,0c16.4,0,29,4.6,37.9,13.8c8.9,9.2,13.3,21,13.3,35.3c0,17.1-6.7,32.1-20,45.1c-13.3,13-29.5,19.5-48.6,19.5
		c-16.4,0-29-4.4-37.9-13.3c-8.9-8.9-13-21.2-12.3-36.9c0-15.7,6-30.2,17.9-43.5S297.3,0,318.5,0 M213,512
		c-34.1,0-43.3-30.4-27.6-91.1l30.7-130c4.8-19.1,4.8-28.7,0-28.7c-4.1,0-13.3,3.1-27.6,9.2c-14.3,6.1-26.6,12.6-36.9,19.5
		l-13.3-22.5c30.7-26.6,63-48.1,96.8-64.5s59.6-24.6,77.3-24.6c26.6,0,32.8,27.6,18.4,82.9l-35.8,136.2c-5.5,21.8-4.4,32.8,3.1,32.8
		c15,0,35.2-10.2,60.4-30.7l15.4,20.5c-28.7,29.4-58.5,51.9-89.6,67.6S229.4,512,213,512'
        />
      </g>
    </svg>
  );
}
